"use client";

import { useAppPopupManager } from "@/contexts/AppPopupManagerContext";
import { KYCPageDevOrchestrator } from "../";

export function KYCDevPopup() {
  const { closeCurrentPopup } = useAppPopupManager();

  return (
    <div className="p-2 sm:p-3 md:p-4 lg:p-6">
      <KYCPageDevOrchestrator onClose={closeCurrentPopup} />
    </div>
  );
}

export default KYCDevPopup;
